module.exports = {
  'en': {
    'VOTEFRIEND': {
      '1': 'Home',
      '2': 'Vote Friends',
      '3': 'Rules & Prize',
      '4': 'โครงการเพื่อนช่วยเพื่อน',
      '5': 'เราจะสำเร็จได้ก็ต่อเมื่อช่วยคนอื่นให้สำเร็จ',
      '6': 'Vote Friends',
      '7': 'ให้คะแนนความช่วยเหลือ เพื่อตอบแทนความมีน้ำใจแก่เพื่อนของคุณ เพื่อให้เขาได้รับรางวัลในครั้งนี้',
      '8': 'Previous',
      '9': 'Next',
      '10': 'Pages',
      '11': 'Rules & Prize',
      '12': 'รายละเอียดการให้คะแนนโหวต และรายละเอียดของรางวัล',
      '13': 'How to Vote',
      '14': 'ให้คะแนนผ่านโปรแกรมในระบบ ESS ซึ่งบริษัทฯ จะทำการพัฒนาขึ้นในเร็วๆนี้',
      '15': 'สามารถให้คะแนนเพื่อนได้วันละ 1 ครั้ง ต่อ 1 คน ภายใน 1 วัน สามารถให้คะแนนเพื่อนกี่คนก็ได้ โดยสามารถเข้าไปแก้ไขคะแนนได้ก่อนเวลา 18:00 น. ในแต่ละวัน',
      '16': 'การให้คะแนนจะต้องระบุเหตุผลที่ให้คะแนนในแต่ละครั้งที่ทำการโหวตด้วย',
      '17': 'Vote Scores',
      '18': '5 Score (100%)',
      '19': 'ช่วยเหลือในการแก้ไขปัญหาเรื่องงาน ทำให้งานของตัวเองผ่านพ้นไปด้วยดี และรู้สึกขอบคุณผู้ช่วยเหลือเป็นอย่างมาก ว้าวถ้าไม่ได้ความช่วยเหลือ ฉันก็คงปวดหัว ไปอีกนาน เพราะไม่รู้จะทำอย่างไร คิดไม่ออก มืดแปดด้าน ขอบคุณมากๆ เลย',
      '20': '4 Score (80%)',
      '21': 'ช่วยเหลือในการแก้ไขปัญหาเรื่องงาน ช่วยให้ ทำงานสำเร็จลุล่วงไปได้เร็วขึ้น ช่วยแนะนำ ในสิ่งที่ไม่รู้มาก่อน ถ้าไม่ได้ความช่วยเหลือก็คง ต้องใช้เวลาอีกนานกว่างานจะสำเร็จ หรือได้ ผลลัพธ์ที่ต้องการ ขอบคุณเพื่อนที่สละเวลา มาช่วยเหลืออย่างจริงจังทั้งแนะนำ และลงมือทำ',
      '22': '3 Score (70%)',
      '23': 'ช่วยเหลือในเรื่องงาน ช่วยให้ทำงานสำเร็จลุล่วง ไปด้วยดี ช่วยชี้แนะว่าจะต้องแก้ไขปัญหาอย่างไร ช่วยทำในบางเรื่องที่ทำให้งานเราสมบูรณ์แบบ ยิ่งขึ้น รู้สึกขอบคุณที่มีเพื่อนร่วมงานแบบนี้ ถ้าไม่ได้การช่วยเหลือในครั้งนี้เราก็อาจ จะต้องใช้เวลาอีกนานกว่างานจะสำเร็จ',
      '24': '2 Score (50%)',
      '25': 'ช่วยเหลือในเรื่องงานบางเรื่อง อาจจะไม่ได้ช่วย ลงมือทำแต่ก็ยังเป็นที่ปรึกษา เป็นเพื่อนให้กำลังใจ ทำให้เราทำงานต่อได้จนสำเร็จ รู้สึกขอบคุณที่มี เพื่อนร่วมงานแบบนี้',
      '26': '1 Score (30-50%)',
      '27': 'ช่วยเหลือในเรื่องเล็กๆ น้อยๆ อาจจะเกี่ยวกับ เรื่องงาน หรือความช่วยเหลือในด้านอื่นๆ ความช่วยเหลือในครั้งนี้ทำให้เรารู้สึกสบายขึ้น ผ่อนคลายมากขึ้น ทำให้เราทำงานต่อได้แบบ ไม่ติดขัด รู้สึกดีใจที่มีเพื่อนแบบนี้',
      '28': 'Announcement',
      '29': 'บริษัทฯ จะประกาศผลคนที่ได้คะแนนสูงสุดทุกๆ Quarter โดยจะเริ่มให้คะแนนตั้งแต่ Quarter',
      '30': 'และประกาศผลในการประชุม Quarterly',
      '31': 'Reward & Prize',
      '32': '1. พนักงานที่ได้คะแนนสูงสุดใน Quarter นั้น จะได้รับเงินรางวัลเป็นจำนวนเงิน 5,000 บาท',
      '33': '2. สำหรับพนักงานที่ได้คะแนนสูงสุดติดต่อกัน 4 Quarter จะได้รับเงินรางวัลเพิ่มอีกเป็นจำนวนเงิน 10,000 บาท',
      '34': 'Vote Scores',
      '35': 'Scoring cause',
      '36': 'Vote Now',
      '37': 'Edit Vote'
    }
  },
  'th': {
    'VOTEFRIEND': {
      '1': 'Home',
      '2': 'Vote Friends',
      '3': 'Rules & Prize',
      '4': 'โครงการเพื่อนช่วยเพื่อน',
      '5': 'เราจะสำเร็จได้ก็ต่อเมื่อช่วยคนอื่นให้สำเร็จ',
      '6': 'Vote Friends',
      '7': 'ให้คะแนนความช่วยเหลือ เพื่อตอบแทนความมีน้ำใจแก่เพื่อนของคุณ เพื่อให้เขาได้รับรางวัลในครั้งนี้',
      '8': 'Previous',
      '9': 'Next',
      '10': 'Pages',
      '11': 'Rules & Prize',
      '12': 'รายละเอียดการให้คะแนนโหวต และรายละเอียดของรางวัล',
      '13': 'How to Vote',
      '14': 'ให้คะแนนผ่านโปรแกรมในระบบ ESS ซึ่งบริษัทฯ จะทำการพัฒนาขึ้นในเร็วๆนี้',
      '15': 'สามารถให้คะแนนเพื่อนได้วันละ 1 ครั้ง ต่อ 1 คน ภายใน 1 วัน สามารถให้คะแนนเพื่อนกี่คนก็ได้ โดยสามารถเข้าไปแก้ไขคะแนนได้ก่อนเวลา 18:00 น. ในแต่ละวัน',
      '16': 'การให้คะแนนจะต้องระบุเหตุผลที่ให้คะแนนในแต่ละครั้งที่ทำการโหวตด้วย',
      '17': 'Vote Scores',
      '18': '5 Score (100%)',
      '19': 'ช่วยเหลือในการแก้ไขปัญหาเรื่องงาน ทำให้งานของตัวเองผ่านพ้นไปด้วยดี และรู้สึกขอบคุณผู้ช่วยเหลือเป็นอย่างมาก ว้าวถ้าไม่ได้ความช่วยเหลือ ฉันก็คงปวดหัว ไปอีกนาน เพราะไม่รู้จะทำอย่างไร คิดไม่ออก มืดแปดด้าน ขอบคุณมากๆ เลย',
      '20': '4 Score (80%)',
      '21': 'ช่วยเหลือในการแก้ไขปัญหาเรื่องงาน ช่วยให้ ทำงานสำเร็จลุล่วงไปได้เร็วขึ้น ช่วยแนะนำ ในสิ่งที่ไม่รู้มาก่อน ถ้าไม่ได้ความช่วยเหลือก็คง ต้องใช้เวลาอีกนานกว่างานจะสำเร็จ หรือได้ ผลลัพธ์ที่ต้องการ ขอบคุณเพื่อนที่สละเวลา มาช่วยเหลืออย่างจริงจังทั้งแนะนำ และลงมือทำ',
      '22': '3 Score (70%)',
      '23': 'ช่วยเหลือในเรื่องงาน ช่วยให้ทำงานสำเร็จลุล่วง ไปด้วยดี ช่วยชี้แนะว่าจะต้องแก้ไขปัญหาอย่างไร ช่วยทำในบางเรื่องที่ทำให้งานเราสมบูรณ์แบบ ยิ่งขึ้น รู้สึกขอบคุณที่มีเพื่อนร่วมงานแบบนี้ ถ้าไม่ได้การช่วยเหลือในครั้งนี้เราก็อาจ จะต้องใช้เวลาอีกนานกว่างานจะสำเร็จ',
      '24': '2 Score (50%)',
      '25': 'ช่วยเหลือในเรื่องงานบางเรื่อง อาจจะไม่ได้ช่วย ลงมือทำแต่ก็ยังเป็นที่ปรึกษา เป็นเพื่อนให้กำลังใจ ทำให้เราทำงานต่อได้จนสำเร็จ รู้สึกขอบคุณที่มี เพื่อนร่วมงานแบบนี้',
      '26': '1 Score (30-50%)',
      '27': 'ช่วยเหลือในเรื่องเล็กๆ น้อยๆ อาจจะเกี่ยวกับ เรื่องงาน หรือความช่วยเหลือในด้านอื่นๆ ความช่วยเหลือในครั้งนี้ทำให้เรารู้สึกสบายขึ้น ผ่อนคลายมากขึ้น ทำให้เราทำงานต่อได้แบบ ไม่ติดขัด รู้สึกดีใจที่มีเพื่อนแบบนี้',
      '28': 'Announcement',
      '29': 'บริษัทฯ จะประกาศผลคนที่ได้คะแนนสูงสุดทุกๆ Quarter โดยจะเริ่มให้คะแนนตั้งแต่ Quarter',
      '30': 'และประกาศผลในการประชุม Quarterly',
      '31': 'Reward & Prize',
      '32': '1. พนักงานที่ได้คะแนนสูงสุดใน Quarter นั้น จะได้รับเงินรางวัลเป็นจำนวนเงิน 5,000 บาท',
      '33': '2. สำหรับพนักงานที่ได้คะแนนสูงสุดติดต่อกัน 4 Quarter จะได้รับเงินรางวัลเพิ่มอีกเป็นจำนวนเงิน 10,000 บาท',
      '34': 'Vote Scores',
      '35': 'Scoring cause',
      '36': 'Vote Now',
      '37': 'Edit Vote'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/votefriend.js